import React, { Fragment, useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
  Dialog,
  tableCellClasses,
  Tooltip,
} from "@mui/material";
import Pagination from "components/Pagination";
import InputField from "components/Input";
import DatePicker from "components/DatePicker";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import {
  FontFamily,
  SearchIcon,
} from "assets";
import moment from "moment";
import DropdownMenu from "components/DropDown";
import { useNavigate } from "react-router-dom";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import { useForm } from "react-hook-form";
import { CircleLoading } from "components/Loaders";
import styled from "@emotion/styled";
import SelectField from "components/Select";
import SimpleDialog from "components/Dialog/SimpleDialog";
import VendorServices from "services/Vendor";

const useStyles = {
  tableHeader: {
    backgroundColor: "#f5f5f5",
    fontWeight: "bold",
  },
  tableCell: {
    // textAlign: 'center',
  },
  notesTextArea: {
    width: "100%",
    marginTop: "20px",
  },
};

const Row = styled(TableRow)({ border: 0 });
const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",
    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const ellipsisStyle = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "50px",
};

const DamagesList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);
  const [selectedDateTo, setSelectedDateTo] = useState(null);
  const [originalData, setOriginalData] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeMenu, setActiveMenu] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [filters, setFilters] = useState({});
  const [loader, setLoader] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [ID, setID] = useState();
  const [subTotal, setSubTotal] = useState(0);

  const [openNotesDialog, setOpenNotesDialog] = useState(false);
  const [notesDate, setNotesDate] = useState(new Date());
  const [notesText, setNotesText] = useState("");
  const [activeRowForNotes, setActiveRowForNotes] = useState(null);

  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const [damagesData, setDamagesData] = useState([]);

  const {
    register,
    getValues,
    formState: { errors },
  } = useForm();

  const { handleSubmit: handleSubmit2 } = useForm();

  const navigate = useNavigate();

  const [vinTotals, setVinTotals] = useState({});

  const getDamagesData = async (page, limit, filter) => {
    try {
      setLoader(true);
      const Page = page ? page : currentPage;
      const Limit = limit ? limit : pageLimit;
      const Filter = { ...filters, ...filter };
      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);

      let params = {
        page: Page,
        limit: Limit,
      };

      params = { ...params, ...Filter };

      const { data } = await VendorServices.getDamages(params);
      setDamagesData(data?.damages?.rows);
      setTotalCount(data?.damages?.count);
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const handleDelete = async () => {
    try {
      if (!ID) {
        throw new Error("ID not found for the selected damage.");
      }

      await VendorServices.deleteDamage({ damage_id: ID });
      SuccessToaster("Damages deleted successfully");
      setOpenDeleteModal(false);
      getDamagesData();
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getVendorDropdown();
    getDamagesData();
  }, []);

  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();

  // *For Handle Date
  const handleFromDate = (newDate) => {
    try {
      if (newDate == "Invalid Date") {
        setFromDate("invalid");
        return;
      }
      setFromDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleToDate = (newDate) => {
    try {
      if (newDate == "Invalid Date") {
        setToDate("invalid");
        return;
      }
      setToDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null);
  };

  const handleFilter = async () => {
    try {
      if ((fromDate && !toDate) || (!fromDate && toDate)) {
        ErrorToaster("Please select both From and To date.");
        return;
      }
      const filterPayload = {
        search: getValues("search"),
        status: selectedStatus?.id,
        vendor_id: selectedVendor?.id,
        from_date: fromDate
          ? moment(new Date(fromDate)).format("YYYY-MM-DD")
          : "",
        to_date: toDate ? moment(new Date(toDate)).format("YYYY-MM-DD") : "",
      };

      setLoader(true);

      if (isSearching) return;

      setIsSearching(true);

      await getDamagesData(1, "", filterPayload);
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setIsSearching(false);
      setLoader(false);
    }
  };

  // const handleFilter = async (data) => {
  //     if (!data) {
  //         return;
  //     }

  //     setLoader(true);
  //     if (isSearching) return;

  //     setIsSearching(true);
  //     try {
  //         await getDamagesData(1, "", data);

  //     } catch (err) {
  //         console.error("Search failed:", err);
  //     } finally {
  //         setIsSearching(false);
  //         setLoader(false);
  //     }
  // }

  const creditCustomerCounts = Array.isArray(filteredRows)
    ? filteredRows.reduce((acc, row) => {
      const creditCustomer = row?.creditCustomer?.id || "unknown";
      acc[creditCustomer] = (acc[creditCustomer] || 0) + 1;
      return acc;
    }, {})
    : {};

  const getVendorDropdown = async () => {
    try {
      const { data } = await VendorServices.getVendorDropdown();
      setVendors(data?.vendors);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleOpenNotesDialog = (row) => {
    setActiveRowForNotes(row);
    setNotesDate(new Date());
    setNotesText("");
    setOpenNotesDialog(true);
  };


  const handleSaveNotes = async () => {
    try {
      const payload = {
        damage_id: activeRowForNotes.id,
        booking_id: activeRowForNotes.booking_id,
        vendor_id: activeRowForNotes.vendor_id,
        claimed_amount: activeRowForNotes?.claimed_amount,
        gws_amount: activeRowForNotes?.gws_amount,
        claimed_date: activeRowForNotes?.claimed_date || new Date(),
        credit_amount: activeRowForNotes?.credit_amount,
        remarks: activeRowForNotes?.remarks || null,
        notes: notesText,
        notes_date: notesDate || new Date(),
        reason: activeRowForNotes?.reason,
      };

      const { data } = await VendorServices.updateClaim(payload);

      SuccessToaster("Notes updated successfully");
      setOpenNotesDialog(false);
      setNotesText("");
      getDamagesData();
    } catch (err) {
      ErrorToaster(err);
    }
  };

  const statuses = [
    { id: "full", name: "Fully Claimed" },
    { id: "partial", name: "Partial Claimed" },
    { id: "unclaimed", name: "Un-Claimed" },
    { id: "in_process", name: "In-Process" },
  ];


  return (
    <Fragment>
      <SimpleDialog
        open={openNotesDialog}
        onClose={() => setOpenNotesDialog(false)}
        title={"Update Notes"}
      >
        <Box component="form">
          <Grid container spacing={2}>
            {activeRowForNotes?.damageNotes?.map((note, index) => (
              <Box key={index} sx={{ mb: 2, width: "100%", ml: 1.3, mr: 0.3 }}>
                <Grid item xs={12}>
                  <DatePicker
                    label="Date"
                    size="small"
                    value={moment(note?.notes_date).toDate()}
                    disabled={true}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <InputField
                    label="Notes"
                    size="small"
                    multiline
                    rows={3}
                    value={note?.notes || "No notes"}
                    disabled={true}
                    fullWidth
                  />
                </Grid>
              </Box>
            ))}

            <Grid item xs={12}>
              <DatePicker
                label="Date"
                size="small"
                value={notesDate ? moment(notesDate).toDate() : new Date()}
                onChange={(date) => setNotesDate(moment(date).format("YYYY-MM-DD"))}
                disabled={true}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <InputField
                label="Notes"
                size="small"
                multiline
                rows={3}
                value={notesText}
                onChange={(e) => setNotesText(e.target.value)}
                placeholder="Enter new notes"
                fullWidth
              />
            </Grid>

            {/* Save Button */}
            <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
              <PrimaryButton
                title="Save"
                // type="submit"
                buttonStyle={{ minWidth: 120 }}
                onClick={handleSaveNotes}
              />
            </Grid>
          </Grid>
        </Box>
      </SimpleDialog>

      <Dialog
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Typography
          sx={{
            p: 3,
            px: 5,
            fontSize: 17,
            fontFamily: FontFamily.openSans,
            fontWeight: "bold",
          }}
          id="alert-dialog-title"
        >
          {"Are You Sure You Want To Delete Damages Entry?"}
        </Typography>

        <Grid item xs={12} sm={12} sx={{ mb: 2, textAlign: "center" }}>
          <PrimaryButton
            title="No"
            type="submit"
            buttonStyle={{
              minWidth: "120px",
            }}
            onClick={() => {
              setOpenDeleteModal(false);
            }}
          />
          <Box component={"span"} sx={{ mx: 1 }} />
          <PrimaryButton
            title="Yes"
            type="button"
            buttonStyle={{
              minWidth: "120px",
              bgcolor: Colors.danger,
              "&:hover": { bgcolor: Colors.danger },
            }}
            bgcolor={Colors?.danger}
            onClick={() => {
              handleDelete();
            }}
          />
        </Grid>
      </Dialog>
      <Grid
        container
        spacing={1}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Grid item xs={12} sm={12} md={11}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              mr: 4,
              my: 4,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: Colors.charcoalGrey,
                fontFamily: FontFamily.NunitoRegular,
              }}
            >
              Damages List
            </Typography>
          </Box>
        </Grid>
        {/* Filters */}
        <Grid item md={11}>
          <Box
            sx={{
              m: "10px 0 10px 0",
            }}
          >
            <Grid
              container
              spacing={1}
              alignItems={"center"}
              justifyContent={"space-between"}
              component={"form"}
              onSubmit={handleSubmit}
            >
              <Grid item xs={12} md={3} sx={{ marginTop: "5px" }}>
                <InputField
                  size={"small"}
                  inputStyle={{ backgroundColor: "#f5f5f5" }}
                  label={"Search"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  placeholder={"Search"}
                  register={register("search")}
                />
              </Grid>
              {/* <Grid item xs={12} md={2.5}>

                                <DatePicker
                                    disableFuture={true}
                                    size="small"
                                    label={"Damage Booking Date"}
                                    value={fromDate}
                                    onChange={(date) => handleToDate(date)}
                                />
                            </Grid> */}
              <Grid item xs={12} sm={3}>
                <DatePicker
                  disableFuture={true}
                  size="small"
                  label={"From Date"}
                  value={fromDate}
                  onChange={(date) => handleFromDate(date)}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <DatePicker
                  disabled={fromDate ? false : true}
                  disableFuture={true}
                  size="small"
                  minDate={fromDate}
                  label={"To Date"}
                  value={toDate}
                  onChange={(date) => handleToDate(date)}
                />
              </Grid>
              <Grid item xs={12} md={3} mt={1}>
                <SelectField
                  size={"small"}
                  label={"Vendor Damaged By"}
                  options={vendors}
                  selected={selectedVendor}
                  onSelect={(value) => setSelectedVendor(value)}
                  error={errors?.vendor?.message}
                  register={register("vendor")}
                />
              </Grid>
              <Grid item xs={12} md={3} mt={1}>
                <SelectField
                  size={"small"}
                  label={"Status"}
                  options={statuses}
                  selected={selectedStatus}
                  onSelect={(value) => setSelectedStatus(value)}
                  error={errors?.status?.message}
                  register={register("status")}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <Box
                  sx={{
                    mt: "28px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <PrimaryButton title={"Search"} onClick={handleFilter} />
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box>
            {loader ? (
              <Box
                sx={{
                  height: "300px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircleLoading />
              </Box>
            ) : (
              <>
                <TableContainer
                  sx={{
                    borderRadius: 2,
                    maxWidth: "calc(100vw - 330px)",
                  }}
                >
                  <Table stickyHeader sx={{ minWidth: 500 }}>
                    <TableHead>
                      <TableRow>
                        <Cell
                          sx={{
                            bgcolor: Colors.primary,
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          C.Date
                        </Cell>
                        <Cell
                          sx={{
                            bgcolor: Colors.primary,
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          Vendor
                        </Cell>

                        <Cell
                          sx={{
                            bgcolor: Colors.primary,
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          Customer Name
                        </Cell>
                        <Cell
                          sx={{
                            bgcolor: Colors.primary,
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          VIN
                        </Cell>
                        <Cell
                          sx={{
                            bgcolor: Colors.primary,
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          LOT
                        </Cell>
                        <Cell
                          sx={{
                            bgcolor: Colors.primary,
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          Make/Modal/Color
                        </Cell>
                        <Cell
                          sx={{
                            bgcolor: Colors.primary,
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          Credited
                        </Cell>
                        <Cell
                          sx={{
                            bgcolor: Colors.primary,
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          Damage Reaseon
                        </Cell>
                        {/* <Cell
                          sx={{
                            bgcolor: Colors.primary,
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          Notes
                        </Cell> */}
                        <Cell
                          sx={{
                            bgcolor: Colors.primary,
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          Approved By
                        </Cell>
                        <Cell
                          sx={{
                            "&.MuiTableCell-head": {
                              backgroundColor: "#1976D2 !important",
                              color: "white",
                            },
                          }}
                        >
                          Claimed Amount
                        </Cell>
                        <Cell
                          sx={{
                            "&.MuiTableCell-head": {
                              backgroundColor: "#1976D2 !important",
                              color: "white",
                            },
                          }}
                        >
                          On GWS
                        </Cell>
                        <Cell
                          sx={{
                            "&.MuiTableCell-head": {
                              backgroundColor: "#1976D2 !important",
                              color: "white",
                            },
                          }}
                        >
                          Case Closing Date
                        </Cell>
                        <Cell
                          sx={{
                            "&.MuiTableCell-head": {
                              backgroundColor: "#1976D2 !important",
                              color: "white",
                            },
                          }}
                        >
                          Case Closing Remarks
                        </Cell>
                        <Cell>Status</Cell>
                        <Cell
                          sx={{
                            bgcolor: Colors.primary,
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          Action
                        </Cell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {damagesData?.length > 0 ? (
                        <Fragment>
                          {damagesData?.map((row, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                bgcolor:
                                  damagesData.indexOf(row) % 2 !== 0
                                    ? "#EFF8E7"
                                    : "inherit",
                              }}
                            >
                              <Cell>
                                {moment(row?.booked_date).format(
                                  "MM-DD-YYYY"
                                ) ?? "-"}
                              </Cell>
                              <Cell>{row?.vendor?.name ?? "-"}</Cell>
                              <Cell>
                                {
                                  <Box>
                                    {/* Tooltip with ellipsis on customer name */}
                                    <Tooltip
                                      className="pdf-hide"
                                      title={
                                        row?.booking?.customer?.name ?? "-"
                                      }
                                      arrow
                                      placement="top"
                                      slotProps={{
                                        popper: {
                                          modifiers: [
                                            {
                                              name: "offset",
                                              options: {
                                                offset: [10, -2],
                                              },
                                            },
                                          ],
                                        },
                                      }}
                                    >
                                      <span
                                        style={{
                                          whiteSpace: "nowrap", // Prevents text from wrapping
                                          overflow: "hidden", // Ensures text overflow is hidden
                                          textOverflow: "ellipsis", // Adds ellipsis for overflowing text
                                          display: "inline-block", // Makes the span behave like a block element
                                          maxWidth: "160px", // Adjust based on the column width
                                        }}
                                      >
                                        {row?.booking?.customer?.name ?? "-"}
                                      </span>
                                    </Tooltip>

                                    <Box
                                      component={"div"}
                                      className="pdf-show"
                                      sx={{ display: "none !important" }}
                                    >
                                      {row?.booking?.customer?.name ?? "-"}
                                    </Box>
                                  </Box>
                                }
                              </Cell>
                              <Cell>{row?.booking?.vin ?? "-"}</Cell>
                              <Cell>{row?.booking?.lot_number ?? "-"}</Cell>
                              <Cell>
                                {row?.booking?.make_name
                                  ? row?.booking?.make_name
                                  : row?.booking?.veh_make?.name}
                                {"-"}
                                {row?.booking?.model_name
                                  ? row?.booking?.model_name
                                  : row?.booking?.veh_model?.name}
                                {"-"}
                                {row?.booking?.color ?? "-"}
                              </Cell>
                              <Cell>{row?.credit_amount ?? "-"}</Cell>
                              <Cell>
                                {
                                  <Box>
                                    <Tooltip
                                      className="pdf-hide"
                                      title={row?.reason ?? "-"}
                                      arrow
                                      placement="top"
                                      slotProps={{
                                        popper: {
                                          modifiers: [
                                            {
                                              name: "offset",
                                              options: {
                                                offset: [10, -2],
                                              },
                                            },
                                          ],
                                        },
                                      }}
                                    >
                                      <span
                                        style={{
                                          whiteSpace: "nowrap", // Prevents text from wrapping
                                          overflow: "hidden", // Ensures text overflow is hidden
                                          textOverflow: "ellipsis", // Adds ellipsis for overflowing text
                                          display: "inline-block", // Makes the span behave like a block element
                                          maxWidth: "160px", // Adjust based on the column width
                                        }}
                                      >
                                        {row?.reason ?? "-"}
                                      </span>
                                    </Tooltip>

                                    <Box
                                      component={"div"}
                                      className="pdf-show"
                                      sx={{ display: "none !important" }}
                                    >
                                      {row?.reason ?? "-"}
                                    </Box>
                                  </Box>
                                }
                              </Cell>
                              {/* <Cell>
                                {
                                  <Box>
                                    <Tooltip
                                      className="pdf-hide"
                                      title={
                                        row?.damageNotes?.length
                                          ? row.damageNotes
                                            .map((v) => v?.notes)
                                            .join(", ")
                                          : "-"
                                      }
                                      arrow
                                      placement="top"
                                      slotProps={{
                                        popper: {
                                          modifiers: [
                                            {
                                              name: "offset",
                                              options: {
                                                offset: [10, -2],
                                              },
                                            },
                                          ],
                                        },
                                      }}
                                    >
                                      <span
                                        style={{
                                          whiteSpace: "nowrap", // Prevents text from wrapping
                                          overflow: "hidden", // Ensures text overflow is hidden
                                          textOverflow: "ellipsis", // Adds ellipsis for overflowing text
                                          display: "inline-block", // Makes the span behave like a block element
                                          maxWidth: "160px", // Adjust based on the column width
                                        }}
                                      >
                                        {row?.damageNotes?.[0]?.notes ?? "-"}
                                      </span>
                                    </Tooltip>

                                    <Box
                                      component={"div"}
                                      className="pdf-show"
                                      sx={{ display: "none !important" }}
                                    >
                                      {row?.damageNotes?.[0]?.notes ?? "-"}
                                    </Box>
                                  </Box>
                                }
                              </Cell> */}
                              <Cell>
                                {row?.approvedBy ? row?.approvedBy?.name : "-"}
                              </Cell>
                              <Cell>{row?.claimed_amount ?? "-"}</Cell>
                              <Cell>{row?.gws_amount ?? "-"}</Cell>
                              <Cell>
                                {row?.claimed_date
                                  ? moment(row?.claimed_date).format(
                                    "MM-DD-YYYY"
                                  )
                                  : "-"}
                              </Cell>
                              <Cell>
                                {
                                  <Box>
                                    <Tooltip
                                      className="pdf-hide"
                                      title={row?.remarks ?? "-"}
                                      arrow
                                      placement="top"
                                      slotProps={{
                                        popper: {
                                          modifiers: [
                                            {
                                              name: "offset",
                                              options: {
                                                offset: [10, -2],
                                              },
                                            },
                                          ],
                                        },
                                      }}
                                    >
                                      <span
                                        style={{
                                          whiteSpace: "nowrap", // Prevents text from wrapping
                                          overflow: "hidden", // Ensures text overflow is hidden
                                          textOverflow: "ellipsis", // Adds ellipsis for overflowing text
                                          display: "inline-block", // Makes the span behave like a block element
                                          maxWidth: "160px", // Adjust based on the column width
                                        }}
                                      >
                                        {row?.remarks ?? "-"}
                                      </span>
                                    </Tooltip>

                                    <Box
                                      component={"div"}
                                      className="pdf-show"
                                      sx={{ display: "none !important" }}
                                    >
                                      {row?.remarks ?? "-"}
                                    </Box>
                                  </Box>
                                }
                              </Cell>
                              <Cell>
                                {row?.claimed_amount === 0
                                  ? "Un-Claimed"
                                  : row?.claimed_amount === row?.credit_amount
                                    ? "Fully Claimed"
                                    : row?.claimed_amount > 0 &&
                                      row?.claimed_amount < row?.credit_amount
                                      ? "Partial Claimed"
                                      : "In-Process"}
                              </Cell>
                              <Cell>
                                {
                                  <DropdownMenu
                                    item={row}
                                    // permissions={permissions}
                                    navigate={navigate}
                                    isOpen={activeMenu === row?.id}
                                    onToggle={(isOpen) =>
                                      handleMenuToggle(row?.id, isOpen)
                                    }
                                    id={row?.id}
                                    onClickDamagesNotes={() => {
                                      handleOpenNotesDialog(row);
                                    }}
                                    onClickUpdateDamagesClaim={() => {
                                      navigate(`/update-claim/${row?.id}`);
                                    }}
                                    onClickEditDamages={() => {
                                      navigate(`/update-damages/${row?.id}`);
                                    }}
                                    onClickDeleteDamages={() => {
                                      setOpenDeleteModal(true);
                                      setID(row?.id);
                                    }}
                                    onClickViewDamages={() => {
                                      navigate(
                                        `/damages-invoice-details/${row?.id}`
                                      );
                                    }}
                                  />
                                }
                              </Cell>
                            </TableRow>
                          ))}
                        </Fragment>
                      ) : (
                        <TableRow>
                          <Cell
                            colSpan={11}
                            sx={{
                              textAlign: "center",
                              fontWeight: "bold",
                              fontFamily: FontFamily.NunitoRegular,
                              fontSize: "16px",
                            }}
                          >
                            <Box
                              sx={{
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              No Data Found
                            </Box>
                          </Cell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                <Pagination
                  currentPage={currentPage}
                  pageSize={pageLimit}
                  onPageSizeChange={(size) =>
                    getDamagesData(1, size.target.value)
                  }
                  tableCount={damagesData?.length}
                  totalCount={totalCount}
                  onPageChange={(page) => getDamagesData(page, "")}
                />
              </>
            )}
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default DamagesList;
